module.exports = __webpack_public_path__ + "static/media/dashboard_up.bf4cf39c.svg";